export default __webpack_public_path__ + "static/media/database.8abbffa2.png";